import React from "react";
import { TkMultipleLinesWithBorderProps } from "../../../type/componentsType/TkMultipleLinesWithBorder";
import { Box } from "@mui/material";
import "./_style.scss";

/**
 * TkMultipleLinesWithBorderコンポーネントは、複数行のテキストをボーダーで囲んだ表示を提供します。
 *
 * @param {TkMultipleLinesWithBorderProps} props - コンポーネントのプロパティ
 * @param {string} props.className - コンポーネントのクラス名
 * @param {Array<{ leftText: string, rightText: string }>} props.dataList - 表示するデータのリスト
 * @returns {React.ReactElement} TkMultipleLinesWithBorderコンポーネントのレンダリング結果
 */
const TkMultipleLinesWithBorder: React.FC<TkMultipleLinesWithBorderProps> = (
  props
) => {
  const { className, dataList } = props;

  return (
    <Box className={`TkMultipleLinesWithBorderProps ${className}`}>
      {dataList.map((item, index) => {
        return (
          <Box key={index} className="TkMultipleLinesWithBorderProps-line">
            <Box className="TkMultipleLinesWithBorderProps-line-left">
              {item.leftText}
            </Box>
            <Box className="TkMultipleLinesWithBorderProps-line-right">
              {item.rightText}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default TkMultipleLinesWithBorder;
